// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__10zXF","field":"styles_field__3A60d"};